import i18n from '../i18n';

/**
 * Readable label for one of the backend's SCREAMING_SNAKE enum values.
 *
 * The API speaks in codes (`PARTIALLY_DELIVERED`, `NET_45`, `WAREHOUSE_KEEPER`) and the screens
 * used to paint them straight onto badges — which is not English either, so translating them is
 * part of localising the interface rather than a change of behaviour.
 *
 * Unknown values fall through to the code itself. That is the important property: a status the
 * backend adds tomorrow still renders exactly as it does today instead of showing a missing key,
 * so the catalogue can lag the API without breaking a screen.
 *
 *     enumLabel('orderStatus', 'PARTIALLY_DELIVERED')   // "Livrée partiellement" / "Partially delivered"
 *     enumLabel('orderStatus', 'SOMETHING_NEW')         // "SOMETHING_NEW"
 */
export function enumLabel(group: string, value: string | null | undefined): string {
  if (!value) return '—';
  return i18n.t(`domain.${group}.${value}`, { defaultValue: value });
}
